module.exports = __webpack_public_path__ + "static/media/pillar.9f9dd8c8.svg";